<div
  class="flex h-screen bg-slate-50 dark:bg-[#0f172a] text-slate-900 dark:text-slate-100 overflow-hidden"
>
  <div
    class="w-full lg:w-1/2 h-full flex flex-col px-8 sm:px-16 lg:px-24 py-12 overflow-y-auto relative z-10"
  >
    <div class="max-w-xl w-full mx-auto my-auto">
      <router-outlet />
    </div>
  </div>

  <div
    class="hidden lg:flex w-1/2 h-full relative items-center justify-center overflow-hidden transition-colors duration-500"
  >
    <div class="absolute inset-0 bg-slate-50 dark:bg-[#0f172a]"></div>

    <div
      class="absolute top-0 right-0 w-full h-full opacity-40 dark:opacity-20"
      style="background: radial-gradient(circle at 70% 30%, #e0e7ff 0%, transparent 70%)"
    ></div>

    <div
      class="absolute inset-0 opacity-[0.4] dark:opacity-[0.1] text-slate-400 dark:text-slate-300"
      style="
        background-image: radial-gradient(currentColor 1px, transparent 1px);
        background-size: 40px 40px;
      "
    ></div>

    <div class="relative z-10 text-center px-12">
      <div class="mb-10 inline-flex items-center justify-center">
        <img
          ngSrc="/image/logo2.png"
          alt="Logo"
          width="608"
          height="596"
          style="width: 160px; height: auto"
          priority
          class="drop-shadow-xl"
        />
      </div>

      <h2 class="text-3xl font-bold mb-4 tracking-tight text-slate-900 dark:text-white">
        Responsabile Della Conservazione
      </h2>

      <p class="text-lg text-slate-500 dark:text-slate-400 max-w-sm mx-auto leading-relaxed">
        Gestisci la conservazione dei tuoi documenti in modo sicuro e professionale.
      </p>
    </div>
  </div>

  <div class="fixed top-6 right-6 z-50 flex items-center gap-2">
    <a
      [routerLink]="routeInfo().path"
      class="px-5 py-2.5 text-sm font-medium rounded-full bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 shadow-md border border-slate-200 dark:border-white/5 hover:bg-slate-50 dark:hover:bg-slate-700 transition-all duration-200 flex items-center gap-2"
    >
      {{ routeInfo().text }}
    </a>
    <a
      [href]="contactUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="px-5 py-2.5 text-sm font-medium rounded-full bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 shadow-md border border-slate-200 dark:border-white/5 hover:bg-slate-50 dark:hover:bg-slate-700 transition-all duration-200 flex items-center gap-2"
    >
      Per qualsiasi problema contattaci
    </a>
    <app-toggle-dark-mode
      class="shadow-md rounded-full overflow-hidden block border border-slate-200 dark:border-white/5"
    />
  </div>
</div>

<app-info-dialog
  [isOpen]="authService.signupSuccessDialogOpen()"
  title="Registrazione completata!"
  message="Presto riceverai una email con le credenziali per il primo accesso."
  buttonLabel="Vai al login"
  (closed)="closeSignupSuccessDialog()"
/>

<app-info-dialog
  [isOpen]="authService.passwordResetRequestSuccessDialogOpen()"
  title="Richiesta inviata!"
  message="Se i dati forniti corrispondono a un account, riceverai un'email con il link per reimpostare la password."
  buttonLabel="Vai al login"
  (closed)="closePasswordResetRequestDialog()"
/>

<app-info-dialog
  [isOpen]="authService.passwordResetConfirmSuccessDialogOpen()"
  title="Password reimpostata!"
  message="La password è stata reimpostata con successo. Controlla la tua email per la nuova password."
  buttonLabel="Vai al login"
  (closed)="closePasswordResetConfirmDialog()"
/>
